__turbopack_context__.v({
  "item": "section-icon-module-scss-module__H2QTSG__item",
});
